import { render, staticRenderFns } from "./epms3020_waste.vue?vue&type=template&id=7f40b42c&scoped=true"
import script from "./epms3020_waste.vue?vue&type=script&lang=js"
export * from "./epms3020_waste.vue?vue&type=script&lang=js"
import style0 from "./epms3020_waste.vue?vue&type=style&index=0&id=7f40b42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40b42c",
  null
  
)

export default component.exports